import { Search } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Updater } from "use-immer";

import { IgButton } from "@intelligems/ig-theme";
import { KnowledgeListFilters } from "@intelligems/ig-types";
import { Box, Divider, Stack } from "@mui/material";
import { KnowledgeFilters } from "@src/features/ai/pages/knowledge/components/KnowledgeFilters";
import { ADMIN_ROUTES } from "@src/routes/routes";

interface KnowledgeSideNavBarBodyProps {
  drawerOpen: boolean;
  filters: KnowledgeListFilters;
  categories: string[];
  symptoms: string[];
  rootCauses: string[];
  setFilters: Updater<KnowledgeListFilters>;
}

export const KnowledgeSideNavBarBody = ({
  drawerOpen,
  filters,
  categories,
  symptoms,
  rootCauses,
  setFilters,
}: KnowledgeSideNavBarBodyProps) => {
  const navigate = useNavigate();

  if (!drawerOpen) {
    return null;
  }

  return (
    <Box sx={{ overflowY: "auto", maxHeight: "calc(100vh - 64px)" }}>
      <Stack sx={{ p: 2, ml: 2 }}>
        <IgButton
          variant="outlined"
          startIcon={<Search size={16} />}
          fullWidth
          onClick={() => void navigate(ADMIN_ROUTES.KnowledgeSearch)}
        >
          Search
        </IgButton>
      </Stack>
      <Divider />
      <KnowledgeFilters
        filters={filters}
        categories={categories}
        symptoms={symptoms}
        rootCauses={rootCauses}
        setFilters={setFilters}
      />
    </Box>
  );
};
